export default __webpack_public_path__ + "images/SpeakersPhotos/FotografiaArturoGuerreroIBM.jpg?72e3f847";